((window) => {
  window.URL = window.URL || window.webkitURL
  navigator.getUserMedia = (navigator.mediaDevices?navigator.mediaDevices.getUserMedia:navigator.getUserMedia) || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
  
  let Recorder_ = function(stream, config){
    let audioContext = window.AudioContext || window.webkitAudioContext
    const context = new audioContext()

    config = config || {}
    config.channelCount = 1
    config.numberOfInputChannels = config.channelCount
    config.numberOfOutputChannels = config.channelCount
    config.sampleBits = config.sampleBits || 16
    config.sampleRate = config.sampleRate || 16000
    config.bufferSize = 4096 //创建缓存，用来缓存声音
    this.mediaStream = stream
    this.minDuration=2 //时长
    this.maxDuration=60
    this.startRecord=0 //开始录制时间
    this.analyserNode=null

    let audioInput = context.createMediaStreamSource(stream) //将声音输入这个对像
    let volume = context.createGain() //设置音量节点
    audioInput.connect(volume)

    // 创建声音的缓存节点，createScriptProcessor方法的第二个和第三个参数指的是输入和输出都是声道数

    let recorder = context.createScriptProcessor(config.bufferSize, config.channelCount, config.channelCount)
    

    // 判断录音状态
    let isRecording = false
    // 定时器
    let timer = null
    //
    let increament = 0;
    let self = this
    //用来储存读出的麦克风数据，和压缩这些数据，将这些数据转换为WAV文件的格式
    let audioData = {
      size: 0,        //录音文件长度
      buffer: [],     //录音缓存
      inputSampleRate: context.sampleRate,    //输入采样率
      inputSampleBits: 16, //输入采样数位 8, 16
      outputSampleRate: config.sampleRate,    //输出采样率
      oututSampleBits: config.sampleBits,    //输出采样数位 8, 16
      hasClose:false,
      input: function(data) { // 实时存储录音的数据

        // 写音量判断
        let maxVal = Math.max.apply(Math, data);

        if (Math.round(maxVal * 100) > 1) {
          console.log('有声音')
          increament = 0;
          isRecording = true
          this.buffer.push(new Float32Array(data))
          this.size += data.length
        } else {
          console.log('没声音')
          increament++;
          console.log(increament)
          //有数据 且 已录音

          if (this.size > 0 && isRecording == true && increament > 4) {

            // recorder.disconnect()
            // let blob = audioData.getFullWavData()
          
            // console.log("现在停了")
            // this.buffer = []
            // this.size = 0
            // console.log('接着录')
            // if (isRecording) {
            //   audioInput.connect(recorder)
            //   recorder.connect(context.destination)
            // }
            // callBackSrc(blob)
          }
        }
        if(isRecording && Date.now() - self.startRecord >= self.maxDuration*1000){
          console.log('time out stop')
          self.stop()
        }
        /*
        this.buffer.push(new Float32Array(data))  //Float32Array
        this.size += data.length
         */
      },
      getBufferSize:function(){
        return this.size
      },
      getRawData: function() { //合并压缩
        //合并
        let data = new Float32Array(this.size)
        let offset = 0
        for(let i = 0; i < this.buffer.length; i++) {
          data.set(this.buffer[i], offset)
          offset += this.buffer[i].length
        }
        // 压缩
        let getRawDataion = parseInt(this.inputSampleRate /
            this.outputSampleRate)
        let length = data.length / getRawDataion
        let result = new Float32Array(length)

        let index = 0, j = 0
        while (index < length) {
          result[index] = data[j]
          j += getRawDataion
          index++
        }
        return result
      },
      covertWav: function() { // 转换成wav文件数据
        let sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate)
        let sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits)
        let bytes = this.getRawData()
        let dataLength = bytes.length * (sampleBits / 8)
        let buffer = new ArrayBuffer(44 + dataLength)
        let data = new DataView(buffer)
        let offset = 0
        let writeString = function (str) {
          for (var i = 0; i < str.length; i++) {
            data.setUint8(offset + i, str.charCodeAt(i))
          }
        }
        // 资源交换文件标识符
        writeString('RIFF'); offset += 4
        // 下个地址开始到文件尾总字节数,即文件大小-8
        data.setUint32(offset, 36 + dataLength, true); offset += 4
        // WAV文件标志
        writeString('WAVE'); offset += 4
        // 波形格式标志
        writeString('fmt '); offset += 4
        // 过滤字节,一般为 0x10 = 16
        data.setUint32(offset, 16, true); offset += 4
        // 格式类别 (PCM形式采样数据)
        data.setUint16(offset, 1, true); offset += 2
        // 通道数
        data.setUint16(offset, config.channelCount, true); offset += 2
        // 采样率,每秒样本数,表示每个通道的播放速度
        data.setUint32(offset, sampleRate, true); offset += 4
        // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
        data.setUint32(offset, config.channelCount * sampleRate * (sampleBits / 8), true); offset += 4
        // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
        data.setUint16(offset, config.channelCount * (sampleBits / 8), true); offset += 2
        // 每样本数据位数
        data.setUint16(offset, sampleBits, true); offset += 2
        // 数据标识符
        writeString('data'); offset += 4
        // 采样数据总数,即数据总大小-44
        data.setUint32(offset, dataLength, true); offset += 4
        // 写入采样数据
        data = this.reshapeWavData(sampleBits, offset, bytes, data)
        return data
      },
      getFullWavData: function() { // 用blob生成文件
        const data = this.covertWav()
        return new Blob([data], { type: 'audio/wav' })
      },
      closeContext: function(){ //关闭AudioContext否则录音多次会报错
        hasClose=true
        context.close()
      },
      reshapeWavData: function(sampleBits, offset, iBytes, oData) { // 8位采样数位
        if (sampleBits === 8) {
          for (let i = 0; i < iBytes.length; i++, offset++) {
            let s = Math.max(-1, Math.min(1, iBytes[i]))
            let val = s < 0 ? s * 0x8000 : s * 0x7FFF
            val = parseInt(255 / (65535 / (val + 32768)))
            oData.setInt8(offset, val, true)
          }
        } else {
          for (let i = 0; i < iBytes.length; i++, offset += 2) {
            let s = Math.max(-1, Math.min(1, iBytes[i]))
            oData.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true)
          }
        }
        return oData
      },
      getWavBuffer: function() { // 用于绘图wav格式的buffer数据
        const data = this.covertWav()
        return data.buffer
      },
      getPcmBuffer: function() { // pcm buffer 数据
        let bytes = this.getRawData(),
            offset = 0,
            sampleBits = this.oututSampleBits,
            dataLength = bytes.length * (sampleBits / 8),
            buffer = new ArrayBuffer(dataLength),
            data = new DataView(buffer);
        for (var i = 0; i < bytes.length; i++, offset += 2) {
          var s = Math.max(-1, Math.min(1, bytes[i]));
          // 16位直接乘就行了
          data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
        return new Blob([data])
      }
    }

    // 获取音频文件
    this.getBlob = () => {
      console.log('getBlob stop')
      this.stop()
      return audioData.getFullWavData()
    }
    this.getBuffer = () => {
      console.log('get buffer stop')
      this.stop()
      return audioData.getPcmBuffer()
    }
    // 播放
    this.play = (audio) => {
      audio.src = window.URL.createObjectURL(this.getBlob())
      audio.addEventListener("play", () => {
        // this.draw(ctx)
      })
    }
    this.getBufferSize = function(){
      return audioData.getBufferSize()
    }
    // // 播放
    // this.play = (audio, ctx) => {
    //   audio.src = window.URL.createObjectURL(this.getBlob())
    //   audio.addEventListener("play", () => {
    //     // this.draw(ctx)
    //   })
    // }
    // wav文件资源
    // this.wavSrc = () => {
    //   return window.URL.createObjectURL(this.getBlob())
    // }
    this.wavSrc = () => {
      return this.getBlob()
    }
    // pcm 文件
    this.pcmSrc = () => {
      this.stop()
      console.log('pcm src stop')
      return window.URL.createObjectURL(this.getBuffer())
    }
    
    // 开始录音
    this.start = (minDuration,maxDuration,drawWaverCanvas) => {
      //开始之前，先把正在录音停掉
      recorder.disconnect()
      audioInput.disconnect()
      this.analyserNode && this.analyserNode.disconnect();

      isRecording = true
      this.minDuration=minDuration && minDuration>0 ? minDuration : this.minDuration
      this.maxDuration=maxDuration && maxDuration>0 ? maxDuration: this.maxDuration
      this.startRecord=Date.now()
      audioInput.connect(recorder)
      recorder.connect(context.destination)
      
       // 创建音频分析节点
      this.analyserNode = context.createAnalyser();
      // fftSize决定了能够获取到的音频数据的数量
      this.analyserNode.fftSize = 4096;      
      // 音频源连接至analyserNode
      audioInput.connect(this.analyserNode);
      // analyserNode再连接至扬声器播放
      // this.analyserNode.connect(context.destination);
      if(drawWaverCanvas){
        this.drawWaverCanvas = drawWaverCanvas
        this.drawWaverInterval = setInterval(this.drawWaver.bind(this),60)
      }
      // return srcCallback
    }

    // 停止
    this.stop = (callBackSrc) => {
      console.log('-------recorder stop')
      if(!isRecording){
        return;//避免重复回调
      }
      isRecording = false
      recorder.disconnect()
      audioInput.disconnect()
      this.analyserNode && this.analyserNode.disconnect();
      this.analyserNode=null
      console.log('------------------stop recorder')
      let blob = audioData.getFullWavData()
      audioData.buffer = []
      audioData.size = 0
      recorder=null
      if(this.drawWaverInterval){
        clearInterval(this.drawWaverInterval)
      }
      callBackSrc && callBackSrc(blob,{
        duration:(Date.now() - this.startRecord)/1000
      })

    }
    /**
     * 释放麦克风
     */
    this.close=function(){
      
      audioData.closeContext()
      if (this.mediaStream) {
        console.log('释放stream',this.mediaStream)
        this.mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
        this.mediaStream = null;
      }
    }
    this.drawWaver = function(){
      if(this.isRecording &&(!this.analyserNode || this.drawWaverCanvas ) ){
        console.log('-------stop draw waver')
        return;
      }
      let canvas = this.drawWaverCanvas;  
      if(!this.originData){
        this.originData = new Float32Array(this.analyserNode.fftSize);
      }
      else if(this.originData.length!= this.analyserNode.fftSize){
        delete this.originData
        this.originData = new Float32Array(this.analyserNode.fftSize);
      }
   
      const positives = [];
      const negatives = [];
      // 获取当前的实时音频数据
      this.analyserNode.getFloatTimeDomainData(this.originData);
      
      // 每12位数据取一个最大值一个最小值 4096 / 12 = 341.3333
      const { width, height } = canvas.getBoundingClientRect();
     
      let rectCount = Math.floor(width/4)
      let sliceCount = Math.floor(4096/rectCount)
      for (let i = 0; i < rectCount; i++) {
        let temp = this.originData.slice(i * sliceCount, (i + 1) * sliceCount);
        positives.push(Math.max.apply(null, temp));
        negatives.push(Math.min.apply(null, temp));
      }
      // 创建canvas上下文
      if (canvas.getContext) {
        let ctx = canvas.getContext('2d');
        canvas.width = positives.length * 4;
   
        let x = 0;
        let midle = height/2;
        let y = midle
        
        
        ctx.fillStyle = '#fa541c';
        console.log(positives[0],negatives[0])
        // canvas高度200，横坐标在canvas中点100px的位置，横坐标上方绘制正数据，下方绘制负数据
        for (let k = 0; k < positives.length; k++) {
          // 每个矩形宽3px，间隔1px，图形总长度即为 length * 4
          ctx.fillRect(x + 4 * k, y - (midle * positives[k]), 3, midle * positives[k]);
          ctx.fillRect(x + 4 * k, midle, 3, midle * Math.abs(negatives[k]));
        }
      }
  
    }
    // 音频采集
    recorder.onaudioprocess = (e) => {
      audioData.input(e.inputBuffer.getChannelData(0))
    }

    this.saveAsWavFile = (pcmsrt)=>{
      //参数->（base64编码的pcm流，采样频率，声道数，采样位数）
      let header = {
        // OFFS SIZE NOTES
        chunkId: [0x52, 0x49, 0x46, 0x46], // 0    4    "RIFF" = 0x52494646
        chunkSize: 0, // 4    4    36+SubChunk2Size = 4+(8+SubChunk1Size)+(8+SubChunk2Size)
        format: [0x57, 0x41, 0x56, 0x45], // 8    4    "WAVE" = 0x57415645
        subChunk1Id: [0x66, 0x6d, 0x74, 0x20], // 12   4    "fmt " = 0x666d7420
        subChunk1Size: 16, // 16   4    16 for PCM
        audioFormat: 1, // 20   2    PCM = 1
        numChannels: config.channelCount || 1, // 22   2    Mono = 1, Stereo = 2...
        sampleRate: config.sampleRate || 16000, // 24   4    8000, 44100...
        byteRate: 0, // 28   4    SampleRate*NumChannels*BitsPerSample/8
        blockAlign: 0, // 32   2    NumChannels*BitsPerSample/8
        bitsPerSample: config.sampleBits || 16, // 34   2    8 bits = 8, 16 bits = 16
        subChunk2Id: [0x64, 0x61, 0x74, 0x61], // 36   4    "data" = 0x64617461
        subChunk2Size: 0, // 40   4    data size = NumSamples*NumChannels*BitsPerSample/8
      }
      function u32ToArray(i) {
        return [i & 0xff, (i >> 8) & 0xff, (i >> 16) & 0xff, (i >> 24) & 0xff]
      }
      function u16ToArray(i) {
        return [i & 0xff, (i >> 8) & 0xff]
      }
      // console.log(pcmsrt.length)
      // let pcm = Buffer.from(pcmsrt.split(',')[1],'base64')
      let bstr = window.atob(pcmsrt.split(',')[1])
      let n = bstr.length
      let pcm = new Uint8Array(n);
      while (n--) {
        pcm[n] = bstr.charCodeAt(n);
      }

      // let pcm = Uint8Array.from(pcmsrt)
      header.blockAlign = (header.numChannels * header.bitsPerSample) >> 3
      header.byteRate = header.blockAlign * header.sampleRate
      header.subChunk2Size = pcm.length * (header.bitsPerSample >> 3)
      header.chunkSize = 36 + header.subChunk2Size

      let wavHeader = header.chunkId.concat(
        u32ToArray(header.chunkSize),
        header.format,
        header.subChunk1Id,
        u32ToArray(header.subChunk1Size),
        u16ToArray(header.audioFormat),
        u16ToArray(header.numChannels),
        u32ToArray(header.sampleRate),
        u32ToArray(header.byteRate),
        u16ToArray(header.blockAlign),
        u16ToArray(header.bitsPerSample),
        header.subChunk2Id,
        u32ToArray(header.subChunk2Size)
      )
      let wavHeaderUnit8 = new Uint8Array(wavHeader)

      let mergedArray = new Uint8Array(wavHeaderUnit8.length + pcm.length)
      mergedArray.set(wavHeaderUnit8)
      mergedArray.set(pcm, wavHeaderUnit8.length)
      let blob = new Blob([mergedArray], { type: 'audio/wav' })
      return blob
      // let blobUrl = window.URL.createObjectURL(blob)
      // return blobUrl
    }
  }

  /**********************************微信SDK */
  var MyWeChatRecorder={}
  MyWeChatRecorder.get=(callback, config,_this)=>{
    var wxRecord={
        start:function(){
          _this.$wechat.startRecord()
        },
        stop:function(){
          _this.$wechat.stopRecord({
            success:(res)=>{
              console.log('录音结束',res)
            }
          })
        },
        close:function(){

        }
    }
    callback(wxRecord)
  }
  MyWeChatRecorder.gerPermission=()=>{
    return new Promise((resolve)=>{
      resolve()
    })
  }

  /**********************************普通SDK */
  // 获取麦克风
  let H5Recorder={}
  H5Recorder.gerPermission =()=>{
    return new Promise((resolve,reject)=>{
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          audio: true
          // audio: {
          //   echoCancellation: true,
          //   sampleRate: 16000,
          //   channelCount: 1,
          //   noiseSuppression: true
          // }
        }).then((stream)=>{
          console.log('获取到权限')
          if (stream) {
            stream.getTracks().forEach((track) => {
              track.stop();
            });
            stream = null; 
          }
          return resolve('获取权限成功')
        }).catch(err=>{
          console.error('获取录音权限失败',err)
          return reject('未获取到录音权限')
        })
      }
      else{
        console.error('设备不支持录音功能')
        return reject('设备不支持录音功能')
      }
    })
    
  }
  let recorderRec
  H5Recorder.get = (callback, config,this_) => {
    if(callback) {
      //兼容处理
      // navigator.getUserMedia || (navigator.getUserMedia = navigator.mozGetUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia);
      // console.log(navigator.getUserMedia)
 
      if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({
          audio: true
          // audio: {
          //   echoCancellation: true,
          //   sampleRate: 16000,
          //   channelCount: 1,
          //   noiseSuppression: true
          // }
        }, (stream) => {
          recorderRec = new Recorder_(stream, config)
          callback(recorderRec)
        }, (error) => {
          console.log(error)
        }).then((stream)=>{
          recorderRec = new Recorder_(stream, config)
          callback(recorderRec)
        }).catch(err=>{
          console.log(err)
          callback(null,err)
        })
      } else {
        alert("麦克风获取失败")
      }
    }
  }
 

  window.MyRecorder = {
    get:function(callback, config,this_){
      console.log('-------------1')
      H5Recorder.get(callback,config,this_)
    },
    gerPermission:function(){
      return H5Recorder.gerPermission()
    },
    reset(){
      recorderRec && recorderRec.stop()
      recorderRec && recorderRec.close()
      recorderRec=null
    }
  }
})(window)



// WEBPACK FOOTER //
// ./src/audio/js/record.js